import { render, staticRenderFns } from "./ExchangeOrderManagement.vue?vue&type=template&id=a211eb70&scoped=true"
import script from "./ExchangeOrderManagement.vue?vue&type=script&lang=js"
export * from "./ExchangeOrderManagement.vue?vue&type=script&lang=js"
import style0 from "./ExchangeOrderManagement.vue?vue&type=style&index=0&id=a211eb70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a211eb70",
  null
  
)

export default component.exports